import { OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { ReactSVG } from "react-svg";
import { useEffect, useState } from "react";
import useInventory from "../../../../Hooks/useInventory";
import Loading from "../../../../components/LoadingPage/Loading";
import refreshicon from "../../../../assets/images/refresh-icon.svg";
import moment from "moment";

const formatUseUnits = (useUnits: any[], baseUnit?: string): string[] => {
  if (!useUnits || useUnits.length === 0) return ["-"];
  const defaultUnit = useUnits.find((u: any) => u.isDefault);
  const prefix = defaultUnit
    ? `1 ${baseUnit || ""} = ${defaultUnit.conversionFactor ?? ""} ${defaultUnit.unit?.unitName ?? ""}`.trim()
    : "";
  const otherParts = useUnits
    .filter((u: any) => !u.isDefault)
    .map(
      (u: any) => `${u.conversionFactor ?? ""} ${u.unit?.unitName ?? ""}`.trim()
    );
  if (prefix) {
    const result = [prefix, ...otherParts].filter(Boolean);
    return result.length > 0 ? result : ["-"];
  }
  const parts = useUnits.map(
    (u: any) => `${u.conversionFactor ?? ""} ${u.unit?.unitName ?? ""}`.trim()
  );
  const filtered = parts.filter(Boolean);
  return filtered.length > 0 ? filtered : ["-"];
};

export const HistoryTab = ({ selectedItem }: any) => {
  const { getItemHistoryByIdAPI, getItemHistoryByIdLoading } = useInventory();
  const [historyList, setHistoryList] = useState<any[]>([]);

  const fetchHistory = () => {
    if (selectedItem?.id) {
      getItemHistoryByIdAPI(selectedItem.id)
        .then((res: any) => {
          if (res) {
            setHistoryList(res);
          }
        })
        .catch();
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  return (
    <>
      {getItemHistoryByIdLoading ? <Loading /> : null}
      <div className="inventory-tab-head">
        <h4>
          Displaying {historyList?.length || 0} of{" "}
          {historyList?.length || 0} Results
        </h4>
        <div className="inventory-tab-action-wrapper">
          <div className="invt-refresh-icon-box" onClick={fetchHistory}>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip>Refresh History</Tooltip>}
              trigger={["hover", "focus"]}
            >
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={refreshicon}
              />
            </OverlayTrigger>
          </div>
        </div>
      </div>
      <div className="inventory-profile-table-wrapper history-table-wrapper">
        <Table bordered={false} hover={true}>
          <thead>
            <tr>
              <th>Datetime (UTC)</th>
              <th>Created/Edited By</th>
              <th>Item Name</th>
              <th>NDC</th>
              <th>Lot</th>
              <th>Exp Date</th>
              <th>Stock</th>
              <th>Cost</th>
              <th>Rx Type</th>
              <th>UOM</th>
              <th>EMR Units</th>
            </tr>
          </thead>
          <tbody>
            {historyList?.length > 0 ? (
              historyList.map((item: any, index: number) => (
                <tr key={item.id || index}>
                  <td>
                    {(item.updatedOnUtc || item.createdOnUtc)
                      ? moment(item.updatedOnUtc ?? item.createdOnUtc).format(
                        "MM/DD/YYYY hh:mm:ss A"
                      )
                      : "-"}
                  </td>
                  <td>{item.userObject?.userName || "-"}</td>
                  <td>{item.rxName || "-"}</td>
                  <td>{item.ndcCode || "NA"}</td>
                  <td>{item.lotNo || "-"}</td>
                  <td>
                    {item.expiryDate
                      ? moment(item.expiryDate).format("MM/DD/YYYY")
                      : "-"}
                  </td>
                  <td>{item.stock?.stockName || "-"}</td>
                  <td>{item.cptCode != null ? item.cptCode : "-"}</td>
                  <td>{item.rxType?.rxTypeName || "-"}</td>
                  <td>{item.unit?.unitName || "-"}</td>
                  <td style={{ textAlign: "left" }}>
                    {formatUseUnits(item.useUnits, item.unit?.unitName).map(
                      (part, i, arr) => (
                        <div key={i}>
                          {part}
                          {i < arr.length - 1 ? "," : ""}
                        </div>
                      )
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={11} className="text-center">
                  No history records found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};
